import styled from 'styled-components';
import Row from './row';

const BodyRow = styled(Row)`
  border-bottom: 1px solid var(--grey300);
  background-color: var(--white);
`;
export default BodyRow;
